import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {resolve} from '@cred/shared/utils'
import Analytics from '@cred/react-analytics'
import {SchoolSearch} from '../school-search'
import {Input, textInputWithAnalytics} from '../components'
import pure from 'purecss/build/pure.css'
import grid from 'purecss/build/grids-responsive.css'

class FullSchool extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    change: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
    analyticsContexts: PropTypes.array,
    analyticsOptions: PropTypes.object,
    fieldNameStyle: PropTypes.oneOf(['snake', 'camel'])
  }

  static defaultProps = {
    autoFocus: false,
    analyticsContexts: [],
    analyticsOptions: null,
    fieldNameStyle: 'snake'
  }

  constructor(props) {
    super(props)

    this.state = {}
    this.analytics = new Analytics(props.analytics)
  }

  getFieldName = field => {
    const {fieldNameStyle} = this.props

    switch (field) {
      case 'key':
        return fieldNameStyle === 'snake' ? 'key' : 'schoolKey'
      case 'other':
        return fieldNameStyle === 'snake' ? 'other' : 'otherSchool'
    }
  }

  handleSelectSchool = schoolData => {
    const {name, change} = this.props

    change(`${name}.${this.getFieldName('key')}`, schoolData.school_key)
    change(`${name}.name`, schoolData.institution_name)

    this.setState({lastSelectedSchool: schoolData.institution_name})

    setTimeout(() => {
      const {name, title} = this.props

      this.analytics.event({
        name,
        value: schoolData.institution_name,
        title,
        error: null
      })
    }, 0)
  }

  handleFullSchoolBlur = e => {
    const {name, change} = this.props

    change(`${name}.name`, this.state.lastSelectedSchool)
    e.preventDefault()
  }

  render() {
    const {
        name,
        title,
        otherSchoolLabel,
        otherSchoolPlaceholder,
        validate,
        className,
        autoFocus,
        focusAfter,
        formData,
        analyticsContexts,
        analyticsOptions
      } = this.props,
      other =
        resolve(`values.${name}.name`, formData) === 'Other - school not listed'

    return (
      <div className={[pure['pure-g'], className].join(' ')}>
        <div className={pure['pure-u-1']}>
          <SchoolSearch
            name={`${name}.name`}
            autoFocus={autoFocus}
            focusAfter={focusAfter}
            label={title}
            onSelectSchool={this.handleSelectSchool}
            onBlur={this.handleFullSchoolBlur}
            validate={validate}
          />
          <Input type="hidden" name={`${name}.${this.getFieldName('key')}`}/>
        </div>
        {other ?
          <div className={pure['pure-u-1']}>
            <Input
              type="text"
              label={otherSchoolLabel}
              placeholder={otherSchoolPlaceholder}
              autoFocus={autoFocus}
              focusAfter={1}
              name={`${name}.${this.getFieldName('other')}`}
              validate={validate}
              className="mt-16"
              component={textInputWithAnalytics}
              analyticsContexts={analyticsContexts}
              analyticsOptions={analyticsOptions}
            />
          </div>
         :
          ''
        }
      </div>
    )
  }
}

export {FullSchool}

export default FullSchool
